// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export var LocationCorrection;
(function (LocationCorrection) {
    LocationCorrection[LocationCorrection["NUMBER_1"] = 1] = "NUMBER_1";
    LocationCorrection[LocationCorrection["NUMBER_2"] = 2] = "NUMBER_2";
    LocationCorrection[LocationCorrection["NUMBER_3"] = 3] = "NUMBER_3";
    LocationCorrection[LocationCorrection["NUMBER_4"] = 4] = "NUMBER_4";
    LocationCorrection[LocationCorrection["NUMBER_8"] = 8] = "NUMBER_8";
    LocationCorrection[LocationCorrection["NUMBER_9"] = 9] = "NUMBER_9";
    LocationCorrection[LocationCorrection["NUMBER_10"] = 10] = "NUMBER_10";
    LocationCorrection[LocationCorrection["NUMBER_11"] = 11] = "NUMBER_11";
    LocationCorrection[LocationCorrection["NUMBER_12"] = 12] = "NUMBER_12";
    LocationCorrection[LocationCorrection["NUMBER_13"] = 13] = "NUMBER_13";
    LocationCorrection[LocationCorrection["NUMBER_15"] = 15] = "NUMBER_15";
    LocationCorrection[LocationCorrection["NUMBER_17"] = 17] = "NUMBER_17";
    LocationCorrection[LocationCorrection["NUMBER_18"] = 18] = "NUMBER_18";
    LocationCorrection[LocationCorrection["NUMBER_19"] = 19] = "NUMBER_19";
    LocationCorrection[LocationCorrection["NUMBER_22"] = 22] = "NUMBER_22";
    LocationCorrection[LocationCorrection["NUMBER_23"] = 23] = "NUMBER_23";
    LocationCorrection[LocationCorrection["NUMBER_30"] = 30] = "NUMBER_30";
    LocationCorrection[LocationCorrection["NUMBER_31"] = 31] = "NUMBER_31";
})(LocationCorrection || (LocationCorrection = {}));
//# sourceMappingURL=locationCorrection.js.map